import { renderEntityDuplicated as renderDefaultEntityDuplicated } from '@core/audit/renderers/entityDuplicated';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { HistoryLines } from '../HistoryLines';
import {
  readHistoryColor,
  readHistoryLabel,
  vestmentAction,
} from '../historyLabel';

export const renderEntityDuplicated: AuditLogRenderer = (entry) => {
  const label = readHistoryLabel(entry);
  if (label) {
    return (
      <HistoryLines
        title={label}
        action={vestmentAction(
          entry.subjectType,
          'Duplicated',
          Boolean(entry.metadata?.queuedForPrint)
        )}
        color={readHistoryColor(entry)}
      />
    );
  }

  const message = renderDefaultEntityDuplicated(entry);
  if (entry.metadata?.queuedForPrint) {
    return <>{message} and queued for printing</>;
  }

  return message;
};
